import * as React from "react";
/**
 * Empty attachment logo icon for attachment display
 */ export const EmptyAttachmentLogo = (props)=>/*#__PURE__*/ React.createElement("svg", {
        width: "512",
        height: "512",
        viewBox: "0 0 512 512",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M325.006 434.152H107.999C88.4557 434.173 72.001 417.755 72.001 398.159L72 199L191.812 80.8125L205.875 77.848H325.006C344.887 77.848 361 93.9622 361 113.841V398.159C361 417.489 344.543 434.174 325.006 434.152Z",
        fill: "url(#paint0_linear_6325_7914)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M325.006 434.152H107.999C88.4557 434.173 72.001 417.755 72.001 398.159L72 199L191.812 80.8125L205.875 77.848H325.006C344.887 77.848 361 93.9622 361 113.841V398.159C361 417.489 344.543 434.174 325.006 434.152Z",
        fill: "url(#paint1_radial_6325_7914)",
        fillOpacity: "0.6"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M325.006 434.152H107.999C88.4557 434.173 72.001 417.755 72.001 398.159L72 199L191.812 80.8125L205.875 77.848H325.006C344.887 77.848 361 93.9622 361 113.841V398.159C361 417.489 344.543 434.174 325.006 434.152Z",
        fill: "url(#paint2_radial_6325_7914)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M325.006 434.152H107.999C88.4557 434.173 72.001 417.755 72.001 398.159L72 199L191.812 80.8125L205.875 77.848H325.006C344.887 77.848 361 93.9622 361 113.841V398.159C361 417.489 344.543 434.174 325.006 434.152Z",
        fill: "url(#paint3_radial_6325_7914)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M325.006 434.152H107.999C88.4557 434.173 72.001 417.755 72.001 398.159L72 199L191.812 80.8125L205.875 77.848H325.006C344.887 77.848 361 93.9622 361 113.841V398.159C361 417.489 344.543 434.174 325.006 434.152Z",
        fill: "url(#paint4_radial_6325_7914)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M325.006 434.152H107.999C88.4557 434.173 72.001 417.755 72.001 398.159L72 199L191.812 80.8125L205.875 77.848H325.006C344.887 77.848 361 93.9622 361 113.841V398.159C361 417.489 344.543 434.174 325.006 434.152Z",
        fill: "url(#paint5_radial_6325_7914)",
        fillOpacity: "0.3"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M183.562 132.408V155.74C183.562 174.145 168.639 189.055 150.247 189.055H97.8954C88.1826 189.055 78.8721 192.935 72.0332 199.832C73.0526 197.32 74.2332 193.127 80.4012 186.291L179.803 87.9922C184.794 82.9887 191.243 79.783 198.132 78.7395C199.905 78.5007 201.69 78.3624 203.5 78.3624L206.706 78.4001C206.706 78.4001 190.615 78.2744 186.227 87.7156C181.827 97.1569 183.562 132.408 183.562 132.408Z",
        fill: "url(#paint6_linear_6325_7914)"
    }), /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M198.186 79.9565C193.624 81.1029 188.673 83.394 186.567 87.926C185.501 90.2143 184.785 94.133 184.326 98.7914C183.869 103.429 183.673 108.734 183.614 113.751C183.556 118.767 183.636 123.488 183.73 126.955C183.777 128.688 183.828 130.108 183.867 131.094C183.886 131.587 183.903 131.972 183.915 132.233C183.92 132.363 183.925 132.463 183.928 132.53L183.933 132.629L183.933 132.631C183.933 132.631 183.933 132.631 183.434 132.656L183.933 132.631L183.934 132.643V156.118C183.934 174.923 168.256 189.441 149.507 189.441H101.052C94.5998 189.441 83.3357 189.471 72.8609 200.396C72.6698 200.596 72.3533 200.602 72.154 200.411C71.9546 200.22 71.948 199.904 72.1391 199.704C82.9139 188.466 94.5471 188.441 101.052 188.441H149.507C167.747 188.441 182.934 174.327 182.934 156.118V132.668L182.929 132.577C182.926 132.509 182.922 132.409 182.916 132.277C182.904 132.015 182.887 131.628 182.868 131.134C182.829 130.144 182.778 128.72 182.73 126.982C182.636 123.507 182.556 118.772 182.614 113.74C182.673 108.709 182.87 103.372 183.331 98.6934C183.789 94.0354 184.515 89.9627 185.66 87.5041C187.966 82.5427 193.311 80.1504 197.943 78.9866C200.274 78.4008 202.462 78.1165 204.066 77.9785C204.869 77.9094 205.527 77.8768 205.986 77.8614C206.215 77.8538 206.395 77.8504 206.518 77.849C206.579 77.8482 206.627 77.848 206.659 77.848L206.696 77.848L206.706 77.848L206.709 77.848C206.709 77.848 206.71 77.848 206.706 78.3476L206.71 77.848C206.987 77.8502 207.209 78.0758 207.206 78.3519C207.204 78.6281 206.979 78.8502 206.703 78.848L206.701 78.848L206.693 78.848L206.661 78.848C206.632 78.848 206.588 78.8482 206.53 78.8489C206.413 78.8503 206.241 78.8535 206.019 78.8609C205.576 78.8757 204.935 78.9074 204.152 78.9748C202.584 79.1097 200.452 79.3872 198.186 79.9565Z",
        fill: "url(#paint7_linear_6325_7914)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M343 156.504V189.63H330V156.504C330 154.701 330.685 152.973 331.904 151.698C333.123 150.424 334.776 149.708 336.5 149.708C338.224 149.708 339.877 150.424 341.096 151.698C342.315 152.973 343 154.701 343 156.504Z",
        fill: "url(#paint8_radial_6325_7914)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M343 156.504V189.63H330V156.504C330 154.701 330.685 152.973 331.904 151.698C333.123 150.424 334.776 149.708 336.5 149.708C338.224 149.708 339.877 150.424 341.096 151.698C342.315 152.973 343 154.701 343 156.504Z",
        fill: "url(#paint9_linear_6325_7914)",
        fillOpacity: "0.7"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M343 156.504V189.63H330V156.504C330 154.701 330.685 152.973 331.904 151.698C333.123 150.424 334.776 149.708 336.5 149.708C338.224 149.708 339.877 150.424 341.096 151.698C342.315 152.973 343 154.701 343 156.504Z",
        fill: "url(#paint10_radial_6325_7914)",
        fillOpacity: "0.5"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M192 212H361V402C361 413.046 352.046 422 341 422H192V212Z",
        fill: "url(#paint11_linear_6325_7914)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M192 212H361V402C361 413.046 352.046 422 341 422H192V212Z",
        fill: "url(#paint12_linear_6325_7914)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M192 212H361V402C361 413.046 352.046 422 341 422H192V212Z",
        fill: "url(#paint13_radial_6325_7914)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M192 212H361V402C361 413.046 352.046 422 341 422H192V212Z",
        fill: "url(#paint14_linear_6325_7914)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M432 264.5L430.5 256.625L357.75 188.632H266.879C245.407 188.632 228 205.985 228 227.391V353.474C228 374.88 245.407 392.234 266.879 392.234H393.121C414.593 392.234 432 374.88 432 353.474V264.5Z",
        fill: "url(#paint15_linear_6325_7914)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M432 264.5L430.5 256.625L357.75 188.632H266.879C245.407 188.632 228 205.985 228 227.391V353.474C228 374.88 245.407 392.234 266.879 392.234H393.121C414.593 392.234 432 374.88 432 353.474V264.5Z",
        fill: "url(#paint16_linear_6325_7914)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M432 264.5L430.5 256.625L357.75 188.632H266.879C245.407 188.632 228 205.985 228 227.391V353.474C228 374.88 245.407 392.234 266.879 392.234H393.121C414.593 392.234 432 374.88 432 353.474V264.5Z",
        fill: "url(#paint17_linear_6325_7914)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M432 264.5L430.5 256.625L357.75 188.632H266.879C245.407 188.632 228 205.985 228 227.391V353.474C228 374.88 245.407 392.234 266.879 392.234H393.121C414.593 392.234 432 374.88 432 353.474V264.5Z",
        fill: "url(#paint18_radial_6325_7914)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M432 264.5L430.5 256.625L357.75 188.632H266.879C245.407 188.632 228 205.985 228 227.391V353.474C228 374.88 245.407 392.234 266.879 392.234H393.121C414.593 392.234 432 374.88 432 353.474V264.5Z",
        fill: "url(#paint19_radial_6325_7914)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M432 264.5L430.5 256.625L357.75 188.632H266.879C245.407 188.632 228 205.985 228 227.391V353.474C228 374.88 245.407 392.234 266.879 392.234H393.121C414.593 392.234 432 374.88 432 353.474V264.5Z",
        fill: "url(#paint20_radial_6325_7914)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M432 264.5L430.5 256.625L357.75 188.632H266.879C245.407 188.632 228 205.985 228 227.391V353.474C228 374.88 245.407 392.234 266.879 392.234H393.121C414.593 392.234 432 374.88 432 353.474V264.5Z",
        fill: "url(#paint21_radial_6325_7914)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M432 264.5L430.5 256.625L357.75 188.632H266.879C245.407 188.632 228 205.985 228 227.391V353.474C228 374.88 245.407 392.234 266.879 392.234H393.121C414.593 392.234 432 374.88 432 353.474V264.5Z",
        fill: "url(#paint22_radial_6325_7914)",
        fillOpacity: "0.3"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M432 264.5L430.5 256.625L357.75 188.632H266.879C245.407 188.632 228 205.985 228 227.391V353.474C228 374.88 245.407 392.234 266.879 392.234H393.121C414.593 392.234 432 374.88 432 353.474V264.5Z",
        fill: "url(#paint23_radial_6325_7914)",
        fillOpacity: "0.5"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M432 264.5L430.5 256.625L357.75 188.632H266.879C245.407 188.632 228 205.985 228 227.391V353.474C228 374.88 245.407 392.234 266.879 392.234H393.121C414.593 392.234 432 374.88 432 353.474V264.5Z",
        fill: "url(#paint24_radial_6325_7914)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M399.553 252.338L385.781 252.989C374.919 253.503 365.702 245.112 365.188 234.257L363.735 203.53C363.459 197.7 360.81 192.235 356.404 188.407C357.915 188.938 360.662 189.507 364.869 192.956L425.662 248.879C428.754 251.685 430.827 255.402 431.635 259.439C431.825 260.478 431.957 261.528 432.007 262.596L432.075 264.489C432.075 264.489 431.699 254.989 426.005 252.663C420.309 250.329 399.553 252.338 399.553 252.338Z",
        fill: "url(#paint25_linear_6325_7914)"
    }), /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M430.731 259.561C429.933 256.921 428.46 254.109 425.776 253.012C424.417 252.455 422.109 252.144 419.362 252.004C416.63 251.865 413.513 251.897 410.568 252.002C407.623 252.107 404.856 252.285 402.824 252.436C401.808 252.512 400.977 252.581 400.399 252.632C400.111 252.657 399.886 252.677 399.733 252.691C399.656 252.698 399.598 252.704 399.559 252.707L399.501 252.713C399.501 252.713 399.5 252.713 399.464 252.343L399.5 252.713L399.491 252.714L385.711 253.366C374.643 253.89 365.252 245.34 364.729 234.28L363.374 205.646C363.196 201.887 362.722 196.036 356.428 189.083C356.29 188.931 356.302 188.697 356.454 188.559C356.606 188.421 356.841 188.433 356.978 188.585C363.434 195.716 363.934 201.763 364.116 205.611L365.471 234.245C365.975 244.896 375.018 253.128 385.675 252.624L399.438 251.973L399.444 251.972L399.489 251.968C399.529 251.964 399.588 251.959 399.665 251.952C399.819 251.937 400.045 251.917 400.335 251.892C400.915 251.841 401.75 251.772 402.769 251.696C404.807 251.544 407.585 251.365 410.541 251.26C413.497 251.154 416.637 251.122 419.399 251.262C422.146 251.402 424.569 251.715 426.057 252.325C429.067 253.554 430.629 256.655 431.442 259.346C431.852 260.704 432.081 261.984 432.207 262.925C432.27 263.396 432.307 263.782 432.329 264.052C432.34 264.187 432.347 264.293 432.351 264.366C432.354 264.402 432.355 264.43 432.356 264.45L432.357 264.472L432.357 264.478L432.357 264.48C432.357 264.48 432.357 264.48 431.986 264.495L432.357 264.48C432.365 264.685 432.206 264.858 432.001 264.866C431.796 264.874 431.623 264.715 431.615 264.51C431.615 264.51 431.615 264.51 431.615 264.51L431.615 264.509L431.615 264.505L431.614 264.486C431.613 264.469 431.612 264.443 431.61 264.41C431.606 264.342 431.599 264.242 431.589 264.112C431.568 263.854 431.532 263.48 431.471 263.024C431.348 262.11 431.127 260.87 430.731 259.561Z",
        fill: "url(#paint26_linear_6325_7914)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M282.943 107.789C266.958 107.789 254 120.784 254 136.815V190.777C259.469 189.124 263.058 188.594 267.782 188.594V136.815C267.782 128.418 274.569 121.612 282.943 121.612H290.058C298.445 121.612 305.238 128.439 305.219 136.851L305.023 221.573C305.021 222.671 304.584 223.723 303.809 224.499C303.034 225.275 301.983 225.71 300.888 225.71H297.312C296.224 225.71 295.152 225.264 294.384 224.491C293.616 223.718 293.175 222.642 293.178 221.551L293.417 140.43C293.401 138.611 292.671 136.871 291.385 135.589C290.099 134.306 288.36 133.584 286.546 133.578C284.733 133.573 282.99 134.285 281.696 135.56C280.402 136.835 279.662 138.57 279.635 140.389L279.396 221.51C279.366 231.455 287.396 239.532 297.312 239.532H300.888C310.767 239.532 318.783 231.513 318.805 221.605L319 136.883C319.038 120.826 306.069 107.789 290.058 107.789H282.943Z",
        fill: "url(#paint27_radial_6325_7914)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M282.943 107.789C266.958 107.789 254 120.784 254 136.815V190.777C259.469 189.124 263.058 188.594 267.782 188.594V136.815C267.782 128.418 274.569 121.612 282.943 121.612H290.058C298.445 121.612 305.238 128.439 305.219 136.851L305.023 221.573C305.021 222.671 304.584 223.723 303.809 224.499C303.034 225.275 301.983 225.71 300.888 225.71H297.312C296.224 225.71 295.152 225.264 294.384 224.491C293.616 223.718 293.175 222.642 293.178 221.551L293.417 140.43C293.401 138.611 292.671 136.871 291.385 135.589C290.099 134.306 288.36 133.584 286.546 133.578C284.733 133.573 282.99 134.285 281.696 135.56C280.402 136.835 279.662 138.57 279.635 140.389L279.396 221.51C279.366 231.455 287.396 239.532 297.312 239.532H300.888C310.767 239.532 318.783 231.513 318.805 221.605L319 136.883C319.038 120.826 306.069 107.789 290.058 107.789H282.943Z",
        fill: "url(#paint28_radial_6325_7914)",
        fillOpacity: "0.5"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M282.943 107.789C266.958 107.789 254 120.784 254 136.815V190.777C259.469 189.124 263.058 188.594 267.782 188.594V136.815C267.782 128.418 274.569 121.612 282.943 121.612H290.058C298.445 121.612 305.238 128.439 305.219 136.851L305.023 221.573C305.021 222.671 304.584 223.723 303.809 224.499C303.034 225.275 301.983 225.71 300.888 225.71H297.312C296.224 225.71 295.152 225.264 294.384 224.491C293.616 223.718 293.175 222.642 293.178 221.551L293.417 140.43C293.401 138.611 292.671 136.871 291.385 135.589C290.099 134.306 288.36 133.584 286.546 133.578C284.733 133.573 282.99 134.285 281.696 135.56C280.402 136.835 279.662 138.57 279.635 140.389L279.396 221.51C279.366 231.455 287.396 239.532 297.312 239.532H300.888C310.767 239.532 318.783 231.513 318.805 221.605L319 136.883C319.038 120.826 306.069 107.789 290.058 107.789H282.943Z",
        fill: "url(#paint29_radial_6325_7914)",
        fillOpacity: "0.8"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M282.943 107.789C266.958 107.789 254 120.784 254 136.815V190.777C259.469 189.124 263.058 188.594 267.782 188.594V136.815C267.782 128.418 274.569 121.612 282.943 121.612H290.058C298.445 121.612 305.238 128.439 305.219 136.851L305.023 221.573C305.021 222.671 304.584 223.723 303.809 224.499C303.034 225.275 301.983 225.71 300.888 225.71H297.312C296.224 225.71 295.152 225.264 294.384 224.491C293.616 223.718 293.175 222.642 293.178 221.551L293.417 140.43C293.401 138.611 292.671 136.871 291.385 135.589C290.099 134.306 288.36 133.584 286.546 133.578C284.733 133.573 282.99 134.285 281.696 135.56C280.402 136.835 279.662 138.57 279.635 140.389L279.396 221.51C279.366 231.455 287.396 239.532 297.312 239.532H300.888C310.767 239.532 318.783 231.513 318.805 221.605L319 136.883C319.038 120.826 306.069 107.789 290.058 107.789H282.943Z",
        fill: "url(#paint30_linear_6325_7914)",
        fillOpacity: "0.7"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M282.943 107.789C266.958 107.789 254 120.784 254 136.815V190.777C259.469 189.124 263.058 188.594 267.782 188.594V136.815C267.782 128.418 274.569 121.612 282.943 121.612H290.058C298.445 121.612 305.238 128.439 305.219 136.851L305.023 221.573C305.021 222.671 304.584 223.723 303.809 224.499C303.034 225.275 301.983 225.71 300.888 225.71H297.312C296.224 225.71 295.152 225.264 294.384 224.491C293.616 223.718 293.175 222.642 293.178 221.551L293.417 140.43C293.401 138.611 292.671 136.871 291.385 135.589C290.099 134.306 288.36 133.584 286.546 133.578C284.733 133.573 282.99 134.285 281.696 135.56C280.402 136.835 279.662 138.57 279.635 140.389L279.396 221.51C279.366 231.455 287.396 239.532 297.312 239.532H300.888C310.767 239.532 318.783 231.513 318.805 221.605L319 136.883C319.038 120.826 306.069 107.789 290.058 107.789H282.943Z",
        fill: "url(#paint31_radial_6325_7914)",
        fillOpacity: "0.8"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M282.943 107.789C266.958 107.789 254 120.784 254 136.815V190.777C259.469 189.124 263.058 188.594 267.782 188.594V136.815C267.782 128.418 274.569 121.612 282.943 121.612H290.058C298.445 121.612 305.238 128.439 305.219 136.851L305.023 221.573C305.021 222.671 304.584 223.723 303.809 224.499C303.034 225.275 301.983 225.71 300.888 225.71H297.312C296.224 225.71 295.152 225.264 294.384 224.491C293.616 223.718 293.175 222.642 293.178 221.551L293.417 140.43C293.401 138.611 292.671 136.871 291.385 135.589C290.099 134.306 288.36 133.584 286.546 133.578C284.733 133.573 282.99 134.285 281.696 135.56C280.402 136.835 279.662 138.57 279.635 140.389L279.396 221.51C279.366 231.455 287.396 239.532 297.312 239.532H300.888C310.767 239.532 318.783 231.513 318.805 221.605L319 136.883C319.038 120.826 306.069 107.789 290.058 107.789H282.943Z",
        fill: "url(#paint32_radial_6325_7914)",
        fillOpacity: "0.6"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M282.943 107.789C266.958 107.789 254 120.784 254 136.815V190.777C259.469 189.124 263.058 188.594 267.782 188.594V136.815C267.782 128.418 274.569 121.612 282.943 121.612H290.058C298.445 121.612 305.238 128.439 305.219 136.851L305.023 221.573C305.021 222.671 304.584 223.723 303.809 224.499C303.034 225.275 301.983 225.71 300.888 225.71H297.312C296.224 225.71 295.152 225.264 294.384 224.491C293.616 223.718 293.175 222.642 293.178 221.551L293.417 140.43C293.401 138.611 292.671 136.871 291.385 135.589C290.099 134.306 288.36 133.584 286.546 133.578C284.733 133.573 282.99 134.285 281.696 135.56C280.402 136.835 279.662 138.57 279.635 140.389L279.396 221.51C279.366 231.455 287.396 239.532 297.312 239.532H300.888C310.767 239.532 318.783 231.513 318.805 221.605L319 136.883C319.038 120.826 306.069 107.789 290.058 107.789H282.943Z",
        fill: "url(#paint33_radial_6325_7914)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M282.943 107.789C266.958 107.789 254 120.784 254 136.815V190.777C259.469 189.124 263.058 188.594 267.782 188.594V136.815C267.782 128.418 274.569 121.612 282.943 121.612H290.058C298.445 121.612 305.238 128.439 305.219 136.851L305.023 221.573C305.021 222.671 304.584 223.723 303.809 224.499C303.034 225.275 301.983 225.71 300.888 225.71H297.312C296.224 225.71 295.152 225.264 294.384 224.491C293.616 223.718 293.175 222.642 293.178 221.551L293.417 140.43C293.401 138.611 292.671 136.871 291.385 135.589C290.099 134.306 288.36 133.584 286.546 133.578C284.733 133.573 282.99 134.285 281.696 135.56C280.402 136.835 279.662 138.57 279.635 140.389L279.396 221.51C279.366 231.455 287.396 239.532 297.312 239.532H300.888C310.767 239.532 318.783 231.513 318.805 221.605L319 136.883C319.038 120.826 306.069 107.789 290.058 107.789H282.943Z",
        fill: "url(#paint34_radial_6325_7914)",
        fillOpacity: "0.4"
    }), /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M286.625 148.46C286.625 149.287 285.953 149.957 285.125 149.957C284.297 149.957 283.625 149.287 283.625 148.46C283.625 147.633 284.297 146.963 285.125 146.963C285.953 146.963 286.625 147.633 286.625 148.46ZM313.672 153.45C313.672 154.277 313 154.947 312.172 154.947C311.343 154.947 310.672 154.277 310.672 153.45C310.672 152.623 311.343 151.953 312.172 151.953C313 151.953 313.672 152.623 313.672 153.45ZM284.375 163.93C285.203 163.93 285.875 163.26 285.875 162.433C285.875 161.606 285.203 160.936 284.375 160.936C283.547 160.936 282.875 161.606 282.875 162.433C282.875 163.26 283.547 163.93 284.375 163.93ZM288.375 221.442C288.375 222.269 287.703 222.94 286.875 222.94C286.047 222.94 285.375 222.269 285.375 221.442C285.375 220.616 286.047 219.945 286.875 219.945C287.703 219.945 288.375 220.616 288.375 221.442ZM312.172 178.526C312.724 178.526 313.172 178.079 313.172 177.528C313.172 176.977 312.724 176.53 312.172 176.53C311.62 176.53 311.172 176.977 311.172 177.528C311.172 178.079 311.62 178.526 312.172 178.526ZM285.375 188.632C285.375 189.183 284.927 189.63 284.375 189.63C283.823 189.63 283.375 189.183 283.375 188.632C283.375 188.08 283.823 187.634 284.375 187.634C284.927 187.634 285.375 188.08 285.375 188.632ZM288.375 205.474C288.927 205.474 289.375 205.027 289.375 204.476C289.375 203.924 288.927 203.478 288.375 203.478C287.823 203.478 287.375 203.924 287.375 204.476C287.375 205.027 287.823 205.474 288.375 205.474ZM310.672 230.993C310.672 231.544 310.224 231.991 309.672 231.991C309.12 231.991 308.672 231.544 308.672 230.993C308.672 230.442 309.12 229.995 309.672 229.995C310.224 229.995 310.672 230.442 310.672 230.993ZM339.047 174.659C339.875 174.659 340.547 173.989 340.547 173.162C340.547 172.335 339.875 171.665 339.047 171.665C338.218 171.665 337.547 172.335 337.547 173.162C337.547 173.989 338.218 174.659 339.047 174.659Z",
        fill: "#FFD461"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M295.609 311.23L296.684 311.23L295.925 311.981C290.965 316.882 290.965 324.861 295.925 329.769L296.684 330.519C299.079 332.886 302.274 334.191 305.68 334.191C309.085 334.191 312.28 332.886 314.675 330.519L315.435 329.769L315.435 330.831C315.435 337.765 321.142 343.411 328.163 343.411L329.243 343.411C336.259 343.411 341.972 337.771 341.972 330.831L341.972 329.769L342.731 330.519C347.69 335.427 355.769 335.427 360.728 330.519L361.493 329.763C366.453 324.861 366.453 316.882 361.493 311.975L360.734 311.224L361.809 311.224C368.824 311.224 374.537 305.584 374.537 298.644L374.537 297.576C374.537 290.642 368.83 284.996 361.809 284.996L360.734 284.996L361.493 284.245C366.453 279.344 366.453 271.365 361.493 266.457L360.728 265.701C358.246 263.247 354.986 262.023 351.733 262.023C348.479 262.023 345.214 263.247 342.737 265.701L341.978 266.452L341.978 265.389C341.978 258.455 336.271 252.809 329.249 252.809L328.169 252.809C321.153 252.809 315.44 258.45 315.44 265.389L315.44 266.452L314.681 265.701C312.286 263.334 309.091 262.029 305.68 262.029C302.268 262.029 299.079 263.334 296.684 265.701L295.919 266.457C290.959 271.359 290.959 279.338 295.919 284.245L296.678 284.996L295.603 284.996C288.588 284.996 282.875 290.636 282.875 297.576L282.875 298.644C282.875 305.578 288.582 311.224 295.603 311.224L295.609 311.23Z",
        fill: "url(#paint35_radial_6325_7914)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M295.609 311.23L296.684 311.23L295.925 311.981C290.965 316.882 290.965 324.861 295.925 329.769L296.684 330.519C299.079 332.886 302.274 334.191 305.68 334.191C309.085 334.191 312.28 332.886 314.675 330.519L315.435 329.769L315.435 330.831C315.435 337.765 321.142 343.411 328.163 343.411L329.243 343.411C336.259 343.411 341.972 337.771 341.972 330.831L341.972 329.769L342.731 330.519C347.69 335.427 355.769 335.427 360.728 330.519L361.493 329.763C366.453 324.861 366.453 316.882 361.493 311.975L360.734 311.224L361.809 311.224C368.824 311.224 374.537 305.584 374.537 298.644L374.537 297.576C374.537 290.642 368.83 284.996 361.809 284.996L360.734 284.996L361.493 284.245C366.453 279.344 366.453 271.365 361.493 266.457L360.728 265.701C358.246 263.247 354.986 262.023 351.733 262.023C348.479 262.023 345.214 263.247 342.737 265.701L341.978 266.452L341.978 265.389C341.978 258.455 336.271 252.809 329.249 252.809L328.169 252.809C321.153 252.809 315.44 258.45 315.44 265.389L315.44 266.452L314.681 265.701C312.286 263.334 309.091 262.029 305.68 262.029C302.268 262.029 299.079 263.334 296.684 265.701L295.919 266.457C290.959 271.359 290.959 279.338 295.919 284.245L296.678 284.996L295.603 284.996C288.588 284.996 282.875 290.636 282.875 297.576L282.875 298.644C282.875 305.578 288.582 311.224 295.603 311.224L295.609 311.23Z",
        fill: "url(#paint36_radial_6325_7914)",
        fillOpacity: "0.7"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M295.609 311.23L296.684 311.23L295.925 311.981C290.965 316.882 290.965 324.861 295.925 329.769L296.684 330.519C299.079 332.886 302.274 334.191 305.68 334.191C309.085 334.191 312.28 332.886 314.675 330.519L315.435 329.769L315.435 330.831C315.435 337.765 321.142 343.411 328.163 343.411L329.243 343.411C336.259 343.411 341.972 337.771 341.972 330.831L341.972 329.769L342.731 330.519C347.69 335.427 355.769 335.427 360.728 330.519L361.493 329.763C366.453 324.861 366.453 316.882 361.493 311.975L360.734 311.224L361.809 311.224C368.824 311.224 374.537 305.584 374.537 298.644L374.537 297.576C374.537 290.642 368.83 284.996 361.809 284.996L360.734 284.996L361.493 284.245C366.453 279.344 366.453 271.365 361.493 266.457L360.728 265.701C358.246 263.247 354.986 262.023 351.733 262.023C348.479 262.023 345.214 263.247 342.737 265.701L341.978 266.452L341.978 265.389C341.978 258.455 336.271 252.809 329.249 252.809L328.169 252.809C321.153 252.809 315.44 258.45 315.44 265.389L315.44 266.452L314.681 265.701C312.286 263.334 309.091 262.029 305.68 262.029C302.268 262.029 299.079 263.334 296.684 265.701L295.919 266.457C290.959 271.359 290.959 279.338 295.919 284.245L296.678 284.996L295.603 284.996C288.588 284.996 282.875 290.636 282.875 297.576L282.875 298.644C282.875 305.578 288.582 311.224 295.603 311.224L295.609 311.23Z",
        fill: "url(#paint37_radial_6325_7914)",
        fillOpacity: "0.7"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M295.609 311.23L296.684 311.23L295.925 311.981C290.965 316.882 290.965 324.861 295.925 329.769L296.684 330.519C299.079 332.886 302.274 334.191 305.68 334.191C309.085 334.191 312.28 332.886 314.675 330.519L315.435 329.769L315.435 330.831C315.435 337.765 321.142 343.411 328.163 343.411L329.243 343.411C336.259 343.411 341.972 337.771 341.972 330.831L341.972 329.769L342.731 330.519C347.69 335.427 355.769 335.427 360.728 330.519L361.493 329.763C366.453 324.861 366.453 316.882 361.493 311.975L360.734 311.224L361.809 311.224C368.824 311.224 374.537 305.584 374.537 298.644L374.537 297.576C374.537 290.642 368.83 284.996 361.809 284.996L360.734 284.996L361.493 284.245C366.453 279.344 366.453 271.365 361.493 266.457L360.728 265.701C358.246 263.247 354.986 262.023 351.733 262.023C348.479 262.023 345.214 263.247 342.737 265.701L341.978 266.452L341.978 265.389C341.978 258.455 336.271 252.809 329.249 252.809L328.169 252.809C321.153 252.809 315.44 258.45 315.44 265.389L315.44 266.452L314.681 265.701C312.286 263.334 309.091 262.029 305.68 262.029C302.268 262.029 299.079 263.334 296.684 265.701L295.919 266.457C290.959 271.359 290.959 279.338 295.919 284.245L296.678 284.996L295.603 284.996C288.588 284.996 282.875 290.636 282.875 297.576L282.875 298.644C282.875 305.578 288.582 311.224 295.603 311.224L295.609 311.23Z",
        fill: "url(#paint38_radial_6325_7914)",
        fillOpacity: "0.7"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M295.609 311.23L296.684 311.23L295.925 311.981C290.965 316.882 290.965 324.861 295.925 329.769L296.684 330.519C299.079 332.886 302.274 334.191 305.68 334.191C309.085 334.191 312.28 332.886 314.675 330.519L315.435 329.769L315.435 330.831C315.435 337.765 321.142 343.411 328.163 343.411L329.243 343.411C336.259 343.411 341.972 337.771 341.972 330.831L341.972 329.769L342.731 330.519C347.69 335.427 355.769 335.427 360.728 330.519L361.493 329.763C366.453 324.861 366.453 316.882 361.493 311.975L360.734 311.224L361.809 311.224C368.824 311.224 374.537 305.584 374.537 298.644L374.537 297.576C374.537 290.642 368.83 284.996 361.809 284.996L360.734 284.996L361.493 284.245C366.453 279.344 366.453 271.365 361.493 266.457L360.728 265.701C358.246 263.247 354.986 262.023 351.733 262.023C348.479 262.023 345.214 263.247 342.737 265.701L341.978 266.452L341.978 265.389C341.978 258.455 336.271 252.809 329.249 252.809L328.169 252.809C321.153 252.809 315.44 258.45 315.44 265.389L315.44 266.452L314.681 265.701C312.286 263.334 309.091 262.029 305.68 262.029C302.268 262.029 299.079 263.334 296.684 265.701L295.919 266.457C290.959 271.359 290.959 279.338 295.919 284.245L296.678 284.996L295.603 284.996C288.588 284.996 282.875 290.636 282.875 297.576L282.875 298.644C282.875 305.578 288.582 311.224 295.603 311.224L295.609 311.23Z",
        fill: "url(#paint39_radial_6325_7914)",
        fillOpacity: "0.7"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M295.609 311.23L296.684 311.23L295.925 311.981C290.965 316.882 290.965 324.861 295.925 329.769L296.684 330.519C299.079 332.886 302.274 334.191 305.68 334.191C309.085 334.191 312.28 332.886 314.675 330.519L315.435 329.769L315.435 330.831C315.435 337.765 321.142 343.411 328.163 343.411L329.243 343.411C336.259 343.411 341.972 337.771 341.972 330.831L341.972 329.769L342.731 330.519C347.69 335.427 355.769 335.427 360.728 330.519L361.493 329.763C366.453 324.861 366.453 316.882 361.493 311.975L360.734 311.224L361.809 311.224C368.824 311.224 374.537 305.584 374.537 298.644L374.537 297.576C374.537 290.642 368.83 284.996 361.809 284.996L360.734 284.996L361.493 284.245C366.453 279.344 366.453 271.365 361.493 266.457L360.728 265.701C358.246 263.247 354.986 262.023 351.733 262.023C348.479 262.023 345.214 263.247 342.737 265.701L341.978 266.452L341.978 265.389C341.978 258.455 336.271 252.809 329.249 252.809L328.169 252.809C321.153 252.809 315.44 258.45 315.44 265.389L315.44 266.452L314.681 265.701C312.286 263.334 309.091 262.029 305.68 262.029C302.268 262.029 299.079 263.334 296.684 265.701L295.919 266.457C290.959 271.359 290.959 279.338 295.919 284.245L296.678 284.996L295.603 284.996C288.588 284.996 282.875 290.636 282.875 297.576L282.875 298.644C282.875 305.578 288.582 311.224 295.603 311.224L295.609 311.23Z",
        fill: "url(#paint40_radial_6325_7914)",
        fillOpacity: "0.7"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M295.609 311.23L296.684 311.23L295.925 311.981C290.965 316.882 290.965 324.861 295.925 329.769L296.684 330.519C299.079 332.886 302.274 334.191 305.68 334.191C309.085 334.191 312.28 332.886 314.675 330.519L315.435 329.769L315.435 330.831C315.435 337.765 321.142 343.411 328.163 343.411L329.243 343.411C336.259 343.411 341.972 337.771 341.972 330.831L341.972 329.769L342.731 330.519C347.69 335.427 355.769 335.427 360.728 330.519L361.493 329.763C366.453 324.861 366.453 316.882 361.493 311.975L360.734 311.224L361.809 311.224C368.824 311.224 374.537 305.584 374.537 298.644L374.537 297.576C374.537 290.642 368.83 284.996 361.809 284.996L360.734 284.996L361.493 284.245C366.453 279.344 366.453 271.365 361.493 266.457L360.728 265.701C358.246 263.247 354.986 262.023 351.733 262.023C348.479 262.023 345.214 263.247 342.737 265.701L341.978 266.452L341.978 265.389C341.978 258.455 336.271 252.809 329.249 252.809L328.169 252.809C321.153 252.809 315.44 258.45 315.44 265.389L315.44 266.452L314.681 265.701C312.286 263.334 309.091 262.029 305.68 262.029C302.268 262.029 299.079 263.334 296.684 265.701L295.919 266.457C290.959 271.359 290.959 279.338 295.919 284.245L296.678 284.996L295.603 284.996C288.588 284.996 282.875 290.636 282.875 297.576L282.875 298.644C282.875 305.578 288.582 311.224 295.603 311.224L295.609 311.23Z",
        fill: "url(#paint41_radial_6325_7914)",
        fillOpacity: "0.7"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M295.609 311.23L296.684 311.23L295.925 311.981C290.965 316.882 290.965 324.861 295.925 329.769L296.684 330.519C299.079 332.886 302.274 334.191 305.68 334.191C309.085 334.191 312.28 332.886 314.675 330.519L315.435 329.769L315.435 330.831C315.435 337.765 321.142 343.411 328.163 343.411L329.243 343.411C336.259 343.411 341.972 337.771 341.972 330.831L341.972 329.769L342.731 330.519C347.69 335.427 355.769 335.427 360.728 330.519L361.493 329.763C366.453 324.861 366.453 316.882 361.493 311.975L360.734 311.224L361.809 311.224C368.824 311.224 374.537 305.584 374.537 298.644L374.537 297.576C374.537 290.642 368.83 284.996 361.809 284.996L360.734 284.996L361.493 284.245C366.453 279.344 366.453 271.365 361.493 266.457L360.728 265.701C358.246 263.247 354.986 262.023 351.733 262.023C348.479 262.023 345.214 263.247 342.737 265.701L341.978 266.452L341.978 265.389C341.978 258.455 336.271 252.809 329.249 252.809L328.169 252.809C321.153 252.809 315.44 258.45 315.44 265.389L315.44 266.452L314.681 265.701C312.286 263.334 309.091 262.029 305.68 262.029C302.268 262.029 299.079 263.334 296.684 265.701L295.919 266.457C290.959 271.359 290.959 279.338 295.919 284.245L296.678 284.996L295.603 284.996C288.588 284.996 282.875 290.636 282.875 297.576L282.875 298.644C282.875 305.578 288.582 311.224 295.603 311.224L295.609 311.23Z",
        fill: "url(#paint42_radial_6325_7914)",
        fillOpacity: "0.7"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M295.609 311.23L296.684 311.23L295.925 311.981C290.965 316.882 290.965 324.861 295.925 329.769L296.684 330.519C299.079 332.886 302.274 334.191 305.68 334.191C309.085 334.191 312.28 332.886 314.675 330.519L315.435 329.769L315.435 330.831C315.435 337.765 321.142 343.411 328.163 343.411L329.243 343.411C336.259 343.411 341.972 337.771 341.972 330.831L341.972 329.769L342.731 330.519C347.69 335.427 355.769 335.427 360.728 330.519L361.493 329.763C366.453 324.861 366.453 316.882 361.493 311.975L360.734 311.224L361.809 311.224C368.824 311.224 374.537 305.584 374.537 298.644L374.537 297.576C374.537 290.642 368.83 284.996 361.809 284.996L360.734 284.996L361.493 284.245C366.453 279.344 366.453 271.365 361.493 266.457L360.728 265.701C358.246 263.247 354.986 262.023 351.733 262.023C348.479 262.023 345.214 263.247 342.737 265.701L341.978 266.452L341.978 265.389C341.978 258.455 336.271 252.809 329.249 252.809L328.169 252.809C321.153 252.809 315.44 258.45 315.44 265.389L315.44 266.452L314.681 265.701C312.286 263.334 309.091 262.029 305.68 262.029C302.268 262.029 299.079 263.334 296.684 265.701L295.919 266.457C290.959 271.359 290.959 279.338 295.919 284.245L296.678 284.996L295.603 284.996C288.588 284.996 282.875 290.636 282.875 297.576L282.875 298.644C282.875 305.578 288.582 311.224 295.603 311.224L295.609 311.23Z",
        fill: "url(#paint43_radial_6325_7914)",
        fillOpacity: "0.7"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M295.609 311.23L296.684 311.23L295.925 311.981C290.965 316.882 290.965 324.861 295.925 329.769L296.684 330.519C299.079 332.886 302.274 334.191 305.68 334.191C309.085 334.191 312.28 332.886 314.675 330.519L315.435 329.769L315.435 330.831C315.435 337.765 321.142 343.411 328.163 343.411L329.243 343.411C336.259 343.411 341.972 337.771 341.972 330.831L341.972 329.769L342.731 330.519C347.69 335.427 355.769 335.427 360.728 330.519L361.493 329.763C366.453 324.861 366.453 316.882 361.493 311.975L360.734 311.224L361.809 311.224C368.824 311.224 374.537 305.584 374.537 298.644L374.537 297.576C374.537 290.642 368.83 284.996 361.809 284.996L360.734 284.996L361.493 284.245C366.453 279.344 366.453 271.365 361.493 266.457L360.728 265.701C358.246 263.247 354.986 262.023 351.733 262.023C348.479 262.023 345.214 263.247 342.737 265.701L341.978 266.452L341.978 265.389C341.978 258.455 336.271 252.809 329.249 252.809L328.169 252.809C321.153 252.809 315.44 258.45 315.44 265.389L315.44 266.452L314.681 265.701C312.286 263.334 309.091 262.029 305.68 262.029C302.268 262.029 299.079 263.334 296.684 265.701L295.919 266.457C290.959 271.359 290.959 279.338 295.919 284.245L296.678 284.996L295.603 284.996C288.588 284.996 282.875 290.636 282.875 297.576L282.875 298.644C282.875 305.578 288.582 311.224 295.603 311.224L295.609 311.23Z",
        fill: "url(#paint44_radial_6325_7914)",
        fillOpacity: "0.8"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M295.609 311.23L296.684 311.23L295.925 311.981C290.965 316.882 290.965 324.861 295.925 329.769L296.684 330.519C299.079 332.886 302.274 334.191 305.68 334.191C309.085 334.191 312.28 332.886 314.675 330.519L315.435 329.769L315.435 330.831C315.435 337.765 321.142 343.411 328.163 343.411L329.243 343.411C336.259 343.411 341.972 337.771 341.972 330.831L341.972 329.769L342.731 330.519C347.69 335.427 355.769 335.427 360.728 330.519L361.493 329.763C366.453 324.861 366.453 316.882 361.493 311.975L360.734 311.224L361.809 311.224C368.824 311.224 374.537 305.584 374.537 298.644L374.537 297.576C374.537 290.642 368.83 284.996 361.809 284.996L360.734 284.996L361.493 284.245C366.453 279.344 366.453 271.365 361.493 266.457L360.728 265.701C358.246 263.247 354.986 262.023 351.733 262.023C348.479 262.023 345.214 263.247 342.737 265.701L341.978 266.452L341.978 265.389C341.978 258.455 336.271 252.809 329.249 252.809L328.169 252.809C321.153 252.809 315.44 258.45 315.44 265.389L315.44 266.452L314.681 265.701C312.286 263.334 309.091 262.029 305.68 262.029C302.268 262.029 299.079 263.334 296.684 265.701L295.919 266.457C290.959 271.359 290.959 279.338 295.919 284.245L296.678 284.996L295.603 284.996C288.588 284.996 282.875 290.636 282.875 297.576L282.875 298.644C282.875 305.578 288.582 311.224 295.603 311.224L295.609 311.23Z",
        fill: "url(#paint45_radial_6325_7914)",
        fillOpacity: "0.8"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M295.609 311.23L296.684 311.23L295.925 311.981C290.965 316.882 290.965 324.861 295.925 329.769L296.684 330.519C299.079 332.886 302.274 334.191 305.68 334.191C309.085 334.191 312.28 332.886 314.675 330.519L315.435 329.769L315.435 330.831C315.435 337.765 321.142 343.411 328.163 343.411L329.243 343.411C336.259 343.411 341.972 337.771 341.972 330.831L341.972 329.769L342.731 330.519C347.69 335.427 355.769 335.427 360.728 330.519L361.493 329.763C366.453 324.861 366.453 316.882 361.493 311.975L360.734 311.224L361.809 311.224C368.824 311.224 374.537 305.584 374.537 298.644L374.537 297.576C374.537 290.642 368.83 284.996 361.809 284.996L360.734 284.996L361.493 284.245C366.453 279.344 366.453 271.365 361.493 266.457L360.728 265.701C358.246 263.247 354.986 262.023 351.733 262.023C348.479 262.023 345.214 263.247 342.737 265.701L341.978 266.452L341.978 265.389C341.978 258.455 336.271 252.809 329.249 252.809L328.169 252.809C321.153 252.809 315.44 258.45 315.44 265.389L315.44 266.452L314.681 265.701C312.286 263.334 309.091 262.029 305.68 262.029C302.268 262.029 299.079 263.334 296.684 265.701L295.919 266.457C290.959 271.359 290.959 279.338 295.919 284.245L296.678 284.996L295.603 284.996C288.588 284.996 282.875 290.636 282.875 297.576L282.875 298.644C282.875 305.578 288.582 311.224 295.603 311.224L295.609 311.23Z",
        fill: "url(#paint46_radial_6325_7914)",
        fillOpacity: "0.8"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M295.609 311.23L296.684 311.23L295.925 311.981C290.965 316.882 290.965 324.861 295.925 329.769L296.684 330.519C299.079 332.886 302.274 334.191 305.68 334.191C309.085 334.191 312.28 332.886 314.675 330.519L315.435 329.769L315.435 330.831C315.435 337.765 321.142 343.411 328.163 343.411L329.243 343.411C336.259 343.411 341.972 337.771 341.972 330.831L341.972 329.769L342.731 330.519C347.69 335.427 355.769 335.427 360.728 330.519L361.493 329.763C366.453 324.861 366.453 316.882 361.493 311.975L360.734 311.224L361.809 311.224C368.824 311.224 374.537 305.584 374.537 298.644L374.537 297.576C374.537 290.642 368.83 284.996 361.809 284.996L360.734 284.996L361.493 284.245C366.453 279.344 366.453 271.365 361.493 266.457L360.728 265.701C358.246 263.247 354.986 262.023 351.733 262.023C348.479 262.023 345.214 263.247 342.737 265.701L341.978 266.452L341.978 265.389C341.978 258.455 336.271 252.809 329.249 252.809L328.169 252.809C321.153 252.809 315.44 258.45 315.44 265.389L315.44 266.452L314.681 265.701C312.286 263.334 309.091 262.029 305.68 262.029C302.268 262.029 299.079 263.334 296.684 265.701L295.919 266.457C290.959 271.359 290.959 279.338 295.919 284.245L296.678 284.996L295.603 284.996C288.588 284.996 282.875 290.636 282.875 297.576L282.875 298.644C282.875 305.578 288.582 311.224 295.603 311.224L295.609 311.23Z",
        fill: "url(#paint47_radial_6325_7914)",
        fillOpacity: "0.8"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M295.609 311.23L296.684 311.23L295.925 311.981C290.965 316.882 290.965 324.861 295.925 329.769L296.684 330.519C299.079 332.886 302.274 334.191 305.68 334.191C309.085 334.191 312.28 332.886 314.675 330.519L315.435 329.769L315.435 330.831C315.435 337.765 321.142 343.411 328.163 343.411L329.243 343.411C336.259 343.411 341.972 337.771 341.972 330.831L341.972 329.769L342.731 330.519C347.69 335.427 355.769 335.427 360.728 330.519L361.493 329.763C366.453 324.861 366.453 316.882 361.493 311.975L360.734 311.224L361.809 311.224C368.824 311.224 374.537 305.584 374.537 298.644L374.537 297.576C374.537 290.642 368.83 284.996 361.809 284.996L360.734 284.996L361.493 284.245C366.453 279.344 366.453 271.365 361.493 266.457L360.728 265.701C358.246 263.247 354.986 262.023 351.733 262.023C348.479 262.023 345.214 263.247 342.737 265.701L341.978 266.452L341.978 265.389C341.978 258.455 336.271 252.809 329.249 252.809L328.169 252.809C321.153 252.809 315.44 258.45 315.44 265.389L315.44 266.452L314.681 265.701C312.286 263.334 309.091 262.029 305.68 262.029C302.268 262.029 299.079 263.334 296.684 265.701L295.919 266.457C290.959 271.359 290.959 279.338 295.919 284.245L296.678 284.996L295.603 284.996C288.588 284.996 282.875 290.636 282.875 297.576L282.875 298.644C282.875 305.578 288.582 311.224 295.603 311.224L295.609 311.23Z",
        fill: "url(#paint48_radial_6325_7914)",
        fillOpacity: "0.8"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M295.609 311.23L296.684 311.23L295.925 311.981C290.965 316.882 290.965 324.861 295.925 329.769L296.684 330.519C299.079 332.886 302.274 334.191 305.68 334.191C309.085 334.191 312.28 332.886 314.675 330.519L315.435 329.769L315.435 330.831C315.435 337.765 321.142 343.411 328.163 343.411L329.243 343.411C336.259 343.411 341.972 337.771 341.972 330.831L341.972 329.769L342.731 330.519C347.69 335.427 355.769 335.427 360.728 330.519L361.493 329.763C366.453 324.861 366.453 316.882 361.493 311.975L360.734 311.224L361.809 311.224C368.824 311.224 374.537 305.584 374.537 298.644L374.537 297.576C374.537 290.642 368.83 284.996 361.809 284.996L360.734 284.996L361.493 284.245C366.453 279.344 366.453 271.365 361.493 266.457L360.728 265.701C358.246 263.247 354.986 262.023 351.733 262.023C348.479 262.023 345.214 263.247 342.737 265.701L341.978 266.452L341.978 265.389C341.978 258.455 336.271 252.809 329.249 252.809L328.169 252.809C321.153 252.809 315.44 258.45 315.44 265.389L315.44 266.452L314.681 265.701C312.286 263.334 309.091 262.029 305.68 262.029C302.268 262.029 299.079 263.334 296.684 265.701L295.919 266.457C290.959 271.359 290.959 279.338 295.919 284.245L296.678 284.996L295.603 284.996C288.588 284.996 282.875 290.636 282.875 297.576L282.875 298.644C282.875 305.578 288.582 311.224 295.603 311.224L295.609 311.23Z",
        fill: "url(#paint49_radial_6325_7914)",
        fillOpacity: "0.8"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M295.609 311.23L296.684 311.23L295.925 311.981C290.965 316.882 290.965 324.861 295.925 329.769L296.684 330.519C299.079 332.886 302.274 334.191 305.68 334.191C309.085 334.191 312.28 332.886 314.675 330.519L315.435 329.769L315.435 330.831C315.435 337.765 321.142 343.411 328.163 343.411L329.243 343.411C336.259 343.411 341.972 337.771 341.972 330.831L341.972 329.769L342.731 330.519C347.69 335.427 355.769 335.427 360.728 330.519L361.493 329.763C366.453 324.861 366.453 316.882 361.493 311.975L360.734 311.224L361.809 311.224C368.824 311.224 374.537 305.584 374.537 298.644L374.537 297.576C374.537 290.642 368.83 284.996 361.809 284.996L360.734 284.996L361.493 284.245C366.453 279.344 366.453 271.365 361.493 266.457L360.728 265.701C358.246 263.247 354.986 262.023 351.733 262.023C348.479 262.023 345.214 263.247 342.737 265.701L341.978 266.452L341.978 265.389C341.978 258.455 336.271 252.809 329.249 252.809L328.169 252.809C321.153 252.809 315.44 258.45 315.44 265.389L315.44 266.452L314.681 265.701C312.286 263.334 309.091 262.029 305.68 262.029C302.268 262.029 299.079 263.334 296.684 265.701L295.919 266.457C290.959 271.359 290.959 279.338 295.919 284.245L296.678 284.996L295.603 284.996C288.588 284.996 282.875 290.636 282.875 297.576L282.875 298.644C282.875 305.578 288.582 311.224 295.603 311.224L295.609 311.23Z",
        fill: "url(#paint50_radial_6325_7914)",
        fillOpacity: "0.8"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M295.609 311.23L296.684 311.23L295.925 311.981C290.965 316.882 290.965 324.861 295.925 329.769L296.684 330.519C299.079 332.886 302.274 334.191 305.68 334.191C309.085 334.191 312.28 332.886 314.675 330.519L315.435 329.769L315.435 330.831C315.435 337.765 321.142 343.411 328.163 343.411L329.243 343.411C336.259 343.411 341.972 337.771 341.972 330.831L341.972 329.769L342.731 330.519C347.69 335.427 355.769 335.427 360.728 330.519L361.493 329.763C366.453 324.861 366.453 316.882 361.493 311.975L360.734 311.224L361.809 311.224C368.824 311.224 374.537 305.584 374.537 298.644L374.537 297.576C374.537 290.642 368.83 284.996 361.809 284.996L360.734 284.996L361.493 284.245C366.453 279.344 366.453 271.365 361.493 266.457L360.728 265.701C358.246 263.247 354.986 262.023 351.733 262.023C348.479 262.023 345.214 263.247 342.737 265.701L341.978 266.452L341.978 265.389C341.978 258.455 336.271 252.809 329.249 252.809L328.169 252.809C321.153 252.809 315.44 258.45 315.44 265.389L315.44 266.452L314.681 265.701C312.286 263.334 309.091 262.029 305.68 262.029C302.268 262.029 299.079 263.334 296.684 265.701L295.919 266.457C290.959 271.359 290.959 279.338 295.919 284.245L296.678 284.996L295.603 284.996C288.588 284.996 282.875 290.636 282.875 297.576L282.875 298.644C282.875 305.578 288.582 311.224 295.603 311.224L295.609 311.23Z",
        fill: "url(#paint51_radial_6325_7914)",
        fillOpacity: "0.8"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M294.369 304.19C294.369 305.023 293.694 305.699 292.86 305.699C292.027 305.699 291.352 305.023 291.352 304.19C291.352 303.357 292.027 302.681 292.86 302.681C293.694 302.681 294.369 303.357 294.369 304.19Z",
        fill: "#FF8A3A"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M345.922 313.909C345.922 314.742 345.247 315.418 344.413 315.418C343.58 315.418 342.904 314.742 342.904 313.909C342.904 313.076 343.58 312.4 344.413 312.4C345.247 312.4 345.922 313.076 345.922 313.909Z",
        fill: "#FF8A3A"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M354.472 328.746C355.49 328.746 356.314 327.922 356.314 326.904C356.314 325.887 355.49 325.063 354.472 325.063C353.455 325.063 352.631 325.887 352.631 326.904C352.631 327.922 353.455 328.746 354.472 328.746Z",
        fill: "#FF8A3A"
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_6325_7914",
        x1: "317",
        y1: "84",
        x2: "-77.2637",
        y2: "571.818",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.406",
        stopColor: "#E7E7E7"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.7",
        stopColor: "#C9F5FF"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint1_radial_6325_7914",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(102.466 187.127) rotate(-165.599) scale(120.682 90.5693)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.297",
        stopColor: "#939393"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.853117",
        stopColor: "#E7E7E7",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint2_radial_6325_7914",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(289.886 -4.67201) rotate(90) scale(208.284 282.602)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.548943",
        stopColor: "#D0D0D0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.707851",
        stopColor: "#E7E7E7",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint3_radial_6325_7914",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(267.5 186.5) rotate(1.16914) scale(49.0102 66.4978)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.548943",
        stopColor: "#C7C7C7"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.863031",
        stopColor: "#E7E7E7",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint4_radial_6325_7914",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(332.5 191) scale(16 41.6888)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.548943",
        stopColor: "#D0D0D0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.760488",
        stopColor: "#E7E7E7",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint5_radial_6325_7914",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(396.272 249.235) rotate(90) scale(271.246 99.4798)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.451259",
        stopColor: "#999999"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "white",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint6_linear_6325_7914",
        x1: "144.101",
        y1: "133.709",
        x2: "192.368",
        y2: "193.902",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.0791142",
        stopColor: "#F2F1F3"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.305853",
        stopColor: "#DCDAD9"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#C3C0BD"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint7_linear_6325_7914",
        x1: "173.686",
        y1: "109.606",
        x2: "150.546",
        y2: "194.002",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#F2F1F3"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.65",
        stopColor: "#C3C0BD"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.905",
        stopColor: "#B3AFAC"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint8_radial_6325_7914",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(300.835 151.522) rotate(96.8058) scale(89.1837 58.1279)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.094",
        stopColor: "#8E88E2"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.24",
        stopColor: "#8E88E2"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.672",
        stopColor: "#5B9BFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#277AE2"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint9_linear_6325_7914",
        x1: "338.156",
        y1: "175.298",
        x2: "328.793",
        y2: "175.298",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.072",
        stopColor: "#0C3BAB",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.863",
        stopColor: "#0031A7"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#0C3BAB",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint10_radial_6325_7914",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(338.624 153.515) rotate(141.897) scale(7.13888 6.58205)"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "white",
        stopOpacity: "0.9"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "white",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint11_linear_6325_7914",
        x1: "276.5",
        y1: "212",
        x2: "276.5",
        y2: "422",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#E8E8E8",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.0712531",
        stopColor: "#C3C3C3"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.938575",
        stopColor: "#C3C3C3"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#E8E8E8",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint12_linear_6325_7914",
        x1: "192",
        y1: "303.327",
        x2: "361",
        y2: "302.298",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.0185151",
        stopColor: "#E7E7E7"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.103934",
        stopColor: "#E7E7E7",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint13_radial_6325_7914",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(305.869 310.034) rotate(-2.0544) scale(172.718 184.53)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.639278",
        stopColor: "#E7E7E7",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.728929",
        stopColor: "#E7E7E7"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint14_linear_6325_7914",
        x1: "334.207",
        y1: "224.383",
        x2: "-0.617999",
        y2: "544.798",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.294075",
        stopColor: "#E7E7E7",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.478109",
        stopColor: "#D8EEF3",
        stopOpacity: "0.516362"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.53134",
        stopColor: "#D3F0F7",
        stopOpacity: "0.676502"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.7",
        stopColor: "#C9F5FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint15_linear_6325_7914",
        x1: "174",
        y1: "226",
        x2: "498.122",
        y2: "303.437",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.115993",
        stopColor: "#D4CFC9"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.360266",
        stopColor: "#E4E2E0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.599865",
        stopColor: "#E6E5E4"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#D4CFC9"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint16_linear_6325_7914",
        x1: "228",
        y1: "332.287",
        x2: "431.998",
        y2: "332.11",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.00482857",
        stopColor: "#C2BBB3"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.0260391",
        stopColor: "#D4CFC9",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.98123",
        stopColor: "#ECE9E6",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#F7F7F6"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint17_linear_6325_7914",
        x1: "330",
        y1: "392.234",
        x2: "329.823",
        y2: "188.632",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.0036047",
        stopColor: "#C2BBB3"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.0207951",
        stopColor: "#D4CFC9",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.98123",
        stopColor: "#ECE9E6",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#F7F7F6"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint18_radial_6325_7914",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(324 334.375) rotate(-57.011) scale(38.1099 18.8363)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.630847",
        stopColor: "#C3BEBA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#F0F0F0",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint19_radial_6325_7914",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(294.75 295) rotate(-57.3431) scale(38.4539 23.2969)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.594499",
        stopColor: "#C3BEBA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.962163",
        stopColor: "#EEEEEE",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint20_radial_6325_7914",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(352 320.5) rotate(-64.7351) scale(35.7307 12.9045)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.623907",
        stopColor: "#C3BEBA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#EFEFEF",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint21_radial_6325_7914",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(304.5 321.25) rotate(-54.4623) scale(32.2587 18.223)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.688288",
        stopColor: "#C3BEBA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#C3BEBA",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint22_radial_6325_7914",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(290 213.583) rotate(-93.0001) scale(72.4396 54.9986)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.463",
        stopColor: "#ACA6A0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.728",
        stopColor: "#ECECEC",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint23_radial_6325_7914",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(290 208.094) rotate(-93.4403) scale(49.9926 28.0645)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.666",
        stopColor: "#ACA6A0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.885514",
        stopColor: "#C6C2BD",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint24_radial_6325_7914",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(411.5 226.5) rotate(134.523) scale(169.712 199.464)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.291119",
        stopColor: "#ACA6A0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.406072",
        stopColor: "#F0F0F0",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint25_linear_6325_7914",
        x1: "396.129",
        y1: "221.869",
        x2: "371.048",
        y2: "252.719",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.189655",
        stopColor: "#F2F1F3"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#C3C0BD"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint26_linear_6325_7914",
        x1: "425.875",
        y1: "264.125",
        x2: "353.75",
        y2: "191.375",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.143532",
        stopColor: "#F2F1F3"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.65",
        stopColor: "#C3C0BD"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.905",
        stopColor: "#B3AFAC"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#F2F1F3"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint27_radial_6325_7914",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(298.703 149.484) rotate(97.0926) scale(90.7436 61.5866)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.094",
        stopColor: "#8E88E2"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.24",
        stopColor: "#8E88E2"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.672",
        stopColor: "#5B9BFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#277AE2"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint28_radial_6325_7914",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(278.714 191.453) rotate(-179.042) scale(7.44537 87.6939)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.159",
        stopColor: "#0D3EB1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.924",
        stopColor: "#0C3BAB",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint29_radial_6325_7914",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(302.933 181.025) rotate(179.756) scale(10.9499 80.156)"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#0C3BAB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#0C3BAB",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint30_linear_6325_7914",
        x1: "267.3",
        y1: "173.66",
        x2: "249.437",
        y2: "173.66",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.072",
        stopColor: "#5D9BFF",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.722",
        stopColor: "#0031A7"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint31_radial_6325_7914",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(286.407 127.619) rotate(89.6912) scale(46.0421 75.7837)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.132",
        stopColor: "#0C3BAB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.291",
        stopColor: "#0C3BAB",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint32_radial_6325_7914",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(298.703 225.175) rotate(90) scale(11.3822 12.7919)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.365",
        stopColor: "white",
        stopOpacity: "0.9"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.844",
        stopColor: "white",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint33_radial_6325_7914",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(288.392 135.085) rotate(175.222) scale(17.9287 13.0201)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.166",
        stopColor: "#C4C0FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#C4C0FF",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint34_radial_6325_7914",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(304.026 116.17) rotate(124.89) scale(6.8094 14.7555)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.13",
        stopColor: "white",
        stopOpacity: "0.9"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.751",
        stopColor: "white",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint35_radial_6325_7914",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(328.706 298.11) rotate(-90) scale(52.0111 52.6195)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.395616",
        stopColor: "#C3ED6D"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.59463",
        stopColor: "#C3ED6D"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.874288",
        stopColor: "#94CA35"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint36_radial_6325_7914",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(293.741 280.929) rotate(-54.6052) scale(11.7227 27.647)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.273403",
        stopColor: "#57B000"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#C3EE6E",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint37_radial_6325_7914",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(295.124 310.98) rotate(-104.56) scale(10.0032 22.7736)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.273403",
        stopColor: "#57B000"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#C3EE6E",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint38_radial_6325_7914",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(314.111 329.59) rotate(-154.832) scale(11.531 26.1118)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.182652",
        stopColor: "#57B000"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#C3EE6E",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint39_radial_6325_7914",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(318.26 264.205) rotate(-11.8887) scale(9.76563 23.0313)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.273403",
        stopColor: "#57B000"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#C3EE6E",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint40_radial_6325_7914",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(360.383 280.803) rotate(-132.325) scale(9.52384 22.4611)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.273403",
        stopColor: "#57B000"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#C3EE6E",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint41_radial_6325_7914",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(364.281 312.238) rotate(-73.8557) scale(9.94848 23.4626)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.273403",
        stopColor: "#57B000"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#C3EE6E",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint42_radial_6325_7914",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(345.42 332.356) rotate(-32.2757) scale(11.3025 26.6559)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.273403",
        stopColor: "#57B000"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#C3EE6E",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint43_radial_6325_7914",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(347.432 254.146) rotate(19.0577) scale(14.6333 34.5114)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.210895",
        stopColor: "#57B000"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#C3EE6E",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint44_radial_6325_7914",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(311.219 273.51) rotate(-40.7858) scale(8.46942 22.6682)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.210895",
        stopColor: "#E0FFA2"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#E0FFA1",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint45_radial_6325_7914",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(331.84 259.427) rotate(-73.092) scale(6.91738 10.6637)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.29802",
        stopColor: "#E0FFA2"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#E0FFA1",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint46_radial_6325_7914",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(354.599 267.6) rotate(-63.144) scale(7.5151 11.5852)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.29802",
        stopColor: "#E0FFA2"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#E0FFA1",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint47_radial_6325_7914",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(358.497 291.742) rotate(-92.5261) scale(8.55856 17.2536)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.264408",
        stopColor: "#E0FFA2"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#E0FFA1",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint48_radial_6325_7914",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(354.976 316.513) rotate(-51.3402) scale(9.66146 27.952)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.0599997",
        stopColor: "#E0FFA2"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#E0FFA1",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint49_radial_6325_7914",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(303.423 317.016) rotate(47.2906) scale(8.89819 25.7437)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.0599997",
        stopColor: "#E0FFA2"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#E0FFA1",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint50_radial_6325_7914",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(296.13 291.616) rotate(100.437) scale(9.71694 28.1125)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.0350108",
        stopColor: "#E0FFA2"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.775711",
        stopColor: "#E0FFA1",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint51_radial_6325_7914",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(328.706 332.356) rotate(-90) scale(8.55024 10.1755)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.0599997",
        stopColor: "#E0FFA2"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#E0FFA1",
        stopOpacity: "0"
    }))));
